import { i18n } from 'i18n';
import { toastError, toastSuccess, toastWarning } from '../../../../../../stores/toast';
import { IFetchDataResponse } from '../../../../../api/types';
import { IBatchBlockingSlotsResponse } from '../store/sagas/submitBulkBlockingSlotsSaga';
import { recordsToCsv } from '../../../../../utils/recordsToCSV';
import { TRANSLATIONS } from '../constants';

export const handleBulkBlockingResponse = (
  response: IFetchDataResponse<IBatchBlockingSlotsResponse>,
  timestamp: string
) => {
  const success = Boolean(response?.success);
  const updated = response?.data?.updatedBlockingSlots ?? [];
  const failed = response?.data?.failedBlockingSlots ?? [];
  const hasResults = updated.length > 0 || failed.length > 0;

  if (!success || !hasResults) {
    toastError(TRANSLATIONS.TOAST.ERROR);
    return;
  }

  if (!failed.length) {
    toastSuccess(TRANSLATIONS.TOAST.SUCCESS);
    return;
  }

  const stores = failed.map(({ store }) => store);
  const total = stores.length;

  const show = total > 9 ? 6 : total;
  const remaining = total - show;

  const remainingText = remaining > 0 ? i18n.t(TRANSLATIONS.TOAST.REMAINING, { remaining }) : '';
  const storeIds = stores.slice(0, show).join(', ');

  const csv = recordsToCsv(failed, {
    columns: ['store', 'start', 'end', 'error'],
    headerMap: {
      store: i18n.t(TRANSLATIONS.CSV_TABLE.STORE),
      start: i18n.t(TRANSLATIONS.CSV_TABLE.START),
      end: i18n.t(TRANSLATIONS.CSV_TABLE.END),
      error: i18n.t(TRANSLATIONS.CSV_TABLE.ERROR),
    },
  });

  if (updated.length) {
    toastSuccess(TRANSLATIONS.TOAST.SUCCESS_PARTIAL);
  } else {
    toastError(TRANSLATIONS.TOAST.ERROR);
  }

  toastWarning(
    i18n.t(TRANSLATIONS.TOAST.WARNING, {
      storeIds,
      remaining: remainingText,
    }),
    20000,
    { caption: TRANSLATIONS.TOAST.DOWNLOAD_BTN, link: true, block: true, onClick: () => downloadCSV(csv, timestamp) }
  );
};

const downloadCSV = (csv: string, timestamp: string) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

  const a = document?.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `${TRANSLATIONS.CSV_TABLE.FILENAME}_${timestamp.replace(/[T\-:,]/g, '_')}.csv`;
  a.click();

  URL.revokeObjectURL(a.href);
};
